<div fxLayout fxLayoutAlign="center center">
  <mat-spinner diameter="48" color="primary"></mat-spinner>
</div>
